<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dadosSideBar"
      @concluido="concluido"
    />

    <vs-table
      noDataText="Nenhum Grupo Encontrado"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      :max-items="itemsPerPage"
      :data="filtrarDados"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="inativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="reativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                v-if="$can($actionsDefault.Exportar, subjectPermission)"
              >
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="colunas"
                    name="grupos.xls"
                    type="xls"
                    >Exportar</downloadexcel
                  >
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!------------ END MENU DE AÇÕES ------------>

          <!------------ START ADD NOVO Grupo ------------>
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="openSideBar({})"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar novo Grupo</span
            >
          </div>
        <!------------ END ADD NOVO Grupo ------------>
        </div>


        <div class="flex space-x-2">

          <vs-input v-model="searchQuery" placeholder="Pesquisar" class="vs-table--search-input px-1"/>

          <!------------ START ITENS POR PÁGINA ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
            <span class="mr-2"
            >{{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                itens.length - paginaAtual * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : itens.length
              }}
              de {{ totalItens }}</span
            >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 5">
                <span>5</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!------------ START INPUT DE PESQUISA ------------>
        </div>



        <!------------ END INPUT DE PESQUISA ------------>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="Nome" search-key="Nome">Nome</vs-th>
        <vs-th sort-key="Tipo" search-key="Tipo">Tipo</vs-th>
        <vs-th sort-key="Descricao" search-key="Descricao">Descrição</vs-th>
        <vs-th sort-key="Status" seach-key="Status">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.nomeGrupo }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.Tipo }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.descricao }}</p>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.deletedAt)"
                class="product-order-status"
                >{{ getStatusString(tr.deletedAt) }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <p class="product-price">
                <vs-button
                  v-tooltip="'Detalhes'"
                  radius
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-search"
                  class="d-inline"
                  @click="opemModal(tr.idGrupo)"
                ></vs-button>
                <vs-button
                  radius
                  v-tooltip="'Editar'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="openSideBar(tr)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                ></vs-button>
                <router-link :to="`listGruposModelos/${tr.idGrupo}`">
                  <vs-button
                    color="dark"
                    type="relief"
                    v-if="$can('Associar Modelos', subjectPermission)"
                    >Associar Modelos</vs-button
                  >
                </router-link>
                <router-link
                  class="ml-2"
                  :to="`listGruposAcessorios/${tr.idGrupo}`"
                >
                  <vs-button
                    color="dark"
                    type="relief"
                    v-if="$can('Associar Acessorios', subjectPermission)"
                    >Associar Acessorios</vs-button
                  >
                </router-link>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>

    </vs-table>
    <!------------ END TABELA ------------>

    <vs-card>
      <vs-pagination
        :max="screenWidth < 650 ? 5 : 9"
        :total="qtdPaginas"
        v-model="paginaAtual"
        @change="handlePageChange"
      ></vs-pagination>
    </vs-card>

    <!------------ START INFORMAÇÕES DO Setor ------------>
    <ModalInfo
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados da ${entidade}`"
      @close="popupActive = false"
    ></ModalInfo>

    <!------------ END INFORMAÇÕES DO Setor ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from './../Includes/SideBar';
import service from '../../services';
import downloadexcel from 'vue-json-excel';
import ModalInfo from '../../components/ModalInfo';
import jwt from 'jsonwebtoken';
import { decryptData } from '../../services/decryptData';

export default {
  props: ['subjectPermission'],
  components: {
    AddNewDataSidebar,
    downloadexcel,
    ModalInfo,
  },
  watch: {
    searchQuery: {
      handler() {
        this.buscaDados();
      },
    },
    itemsPerPage: {
      handler() {
        this.buscaDados();
      }
    },
    paginaAtual: {
      handler() {
        this.buscaDados();
      }
    }
  },
  data() {
    return {
      idEmpresa: null,
      dadosSideBar: {},
      paginaAtual: 1,
      controllerGeral: 'Grupo',
      formSideBar: 'Grupo',
      qtdPaginas: 0,
      entidade: 'Grupo',
      titleSideBar: 'Adicionar Grupo',
      popupActive: false,
      modalSelecionado: [],
      totalItens: 0,
      selected: [],
      itens: [],
      screenWidth: 0,
      colunas: {},
      itemsPerPage: 5,
      searchQuery: '',
      isMounted: false,
      addNewDataSidebar: false,
      mascaraCarro: null,
      mascaraMoto: null,
      mascaraCaminhao: null,
      mascaraAgregado: null,
      mascaraImplemento: null,
      ativaMascarasVeiculos: null,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    filtrarDados() {
      if (!this.searchQuery) {
        return this.itens;
      }

      const removeDiacritics = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
      };

      const query = removeDiacritics(this.searchQuery.toLowerCase());

      const matchesQuery = (item, field) => {
        return item[field] && removeDiacritics(item[field]).toLowerCase().includes(query);
      };

      return this.itens.filter(item => {
        return matchesQuery(item, 'nomeGrupo') || matchesQuery(item, 'Tipo') || matchesQuery(item, 'descricao');
      });
    },
  },
  methods: {
    handlePageChange(page) {
      this.paginaAtual = page;
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    inativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idGrupo);
        });
        service
          .post(this.controllerGeral, 'Inativar', { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Registro inativado(s) com sucesso',
              color: 'success',
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Selecione pelo menos um registro',
          color: 'danger',
        });
      }
    },
    reativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idGrupo);
        });
        service
          .post(this.controllerGeral, 'Reativar', { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Registro reativado(s) com sucesso',
              color: 'success',
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Selecione pelo menos um registro',
          color: 'danger',
        });
      }
    },
    async buscaDados() {
      this.selected = [];
      this.$vs.loading();

      await this.getEmpresa();

      try {

        const fetchPaginatedItems = await service.getFilterPagination(this.controllerGeral, {
          limit: this.itemsPerPage,
          page: this.paginaAtual,
          search: this.searchQuery.length ? this.searchQuery : undefined,
        }, 'listAll/' + this.idEmpresa);

        this.itens = [];
        fetchPaginatedItems.rows.forEach((dadosGrupos) => {
          dadosGrupos.Tipo = dadosGrupos.Grupo_Fipe.nomeTipo;
          delete dadosGrupos.Grupo_Fipe;

          if (this.ativaMascarasVeiculos) {
            if (dadosGrupos.Tipo === 'Carro' && this.mascaraCarro) {
              dadosGrupos.Tipo = this.mascaraCarro;
            }
            if (dadosGrupos.Tipo === 'Moto' && this.mascaraMoto) {
              dadosGrupos.Tipo = this.mascaraMoto;
            }
            if (dadosGrupos.Tipo === 'Caminhão' && this.mascaraCaminhao) {
              dadosGrupos.Tipo = this.mascaraCaminhao;
            }
          }

          this.itens.push(dadosGrupos);
        });
        this.totalItens = fetchPaginatedItems.count;
        this.qtdPaginas = this.totalItens / this.itemsPerPage;

        if (this.qtdPaginas % 1 !== 0) {
          this.qtdPaginas++;
        }
        this.qtdPaginas = parseInt(this.qtdPaginas);

        if (this.itens.length > 0) {
          this.colunas = {};
          if (this.itens[0])
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element !== 'createdAt' &&
                element !== 'updatedAt' &&
                element !== 'deletedAt' &&
                element.indexOf('id') !== 0
              ) {
                this.colunas[element] = element;
              }
            });
        }

        this.$vs.loading.close();
        this.totalItens = fetchPaginatedItems.count;
      } catch (err) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: err,
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    openSideBar(dados) {
      dados.idGrupo == null
        ? (this.titleSideBar = `Adicionar ${this.entidade}`)
        : (this.titleSideBar = `Editar dados do ${this.entidade}`);
      this.dadosSideBar = {
        ...dados,
        mascaraCarro: this.mascaraCarro,
        mascaraMoto: this.mascaraMoto,
        mascaraCaminhao: this.mascaraCaminhao,
        mascaraAgregado: this.mascaraAgregado,
        mascaraImplemento: this.mascaraImplemento,
        ativaMascarasVeiculos: this.ativaMascarasVeiculos,
      };
      this.addNewDataSidebar = true;
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idGrupo == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == null) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
    async getEmpresa() {
      const _token = localStorage.getItem('user-token');
      let id_empresa = jwt.decode(_token).id_empresa;

      if (!id_empresa) {
        id_empresa = !id_empresa
          ? this.$route.params.idEmpresa
          : this.$route.query.idEmpresa;
      }

      this.idEmpresa = id_empresa;
    },
    async buscaDadosEmpresa() {
      if (localStorage.getItem('user-token')) {
        try {
          this.$vs.loading();
          const decoded = jwt.decode(localStorage.getItem('user-token'));
          this.idEmpresa = decoded.id_empresa;

          const res = await service.getAll(
            'g',
            {},
            'empresas/list/idEmpresa/' + this.idEmpresa,
          );
          res.data = decryptData(res.data);

          const [Empresa] = res.data;

          const ativaMascara = Empresa.ativaMascarasVeiculos;
          if (ativaMascara) {
            (this.mascaraCarro = Empresa.mascaraCarro),
              (this.mascaraMoto = Empresa.mascaraMoto),
              (this.mascaraCaminhao = Empresa.mascaraCaminhao),
              (this.mascaraAgregado = Empresa.mascaraAgregado),
              (this.mascaraImplemento = Empresa.mascaraImplemento);
            this.ativaMascarasVeiculos = Empresa.ativaMascarasVeiculos;
          }

          this.$vs.loading.close();
        } catch (error) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
          this.$vs.loading.close();
        }
      }
    },
  },
  async created() {
    await this.buscaDadosEmpresa();
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}
</style>

<!------------ END STYLE ------------>
